import React from 'react';

const LandingLayout = (props) => {
  return (
    <div className="layout-main">
      {props.children}
    </div>
  );
}

export default LandingLayout;
